import { Component, Input } from '@angular/core';

import { Translation } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { PropType } from '@frontend/sports/common/core/utils/extended-types';
import { translationToStr } from '@frontend/sports/common/core/utils/translations';
import { orderBy } from 'lodash-es';

interface IResultedNonRunnerParticipantProp {
    properties?: {
        raceCardNumber?: number;
    };
    name: Translation;
}

@Component({
    selector: 'ms-resulted-non-runner-participants',
    templateUrl: 'resulted-non-runner-participants.component.html',
    standalone: false,
})
export class ResultedNonRunnerParticipantsComponent {
    messages: PropType<PropType<Sitecore, 'horseRacing'>, 'raceResulted'>;

    @Input() set participants(value: IResultedNonRunnerParticipantProp[]) {
        this.nonRunners = orderBy(value, (v) => v.properties?.raceCardNumber ?? '').map((participant) => ({
            raceCardNumber: participant.properties?.raceCardNumber,
            name: translationToStr(participant.name),
        }));
    }

    nonRunners: { raceCardNumber?: number; name: string }[] = [];

    constructor(sitecore: Sitecore) {
        this.messages = sitecore.horseRacing.raceResulted;
    }
}
